/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export const getWRMStats = (): Record<string, any> => {
	// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
	const wrmStats = window.__WRM_INTERNAL_STATS__ ?? {};

	return { wrmStats };
};
